import { Box, Button, IconButton, InputBase, Pagination } from "@mui/material";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { TableMui } from "../../components/mui";
import { useNavigate } from "react-router-dom";
import { Search } from "@mui/icons-material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";

export default () => {
  const navigate = useNavigate();
  const handleFieldButtonClick = () => {
    navigate("/advertiser-account");
  };
  useEffect(() => {
    document.title = "RollingAdz: Art Work Requests" || "Default Title";
  }, []);
  const data = [
    {
      art_id: "is12vd1",
      art_title: "A video of a cat playing with a toy",
      art_by: "Jack",
      status: "Live",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approved",
      date_approved: "15-12-2022",
      approved_by: "Usman",
      start_date: "27-01-2023",
      end_date: "27-05-2023",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      art_id: "is12vd2",
      art_title: "A photo of a beautiful landscape",
      art_by: "Alice",
      status: "Draft",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approved",
      date_approved: "15-12-2022",
      approved_by: "Emma",
      start_date: "15-02-2023",
      end_date: "15-06-2023",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      art_id: "is12vd3",
      art_title: "An illustration of a city skyline",
      art_by: "Bob",
      status: "Pending",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approved",
      date_approved: "15-12-2022",
      approved_by: "Mike",
      start_date: "10-03-2023",
      end_date: "10-07-2023",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      art_id: "is12vd4",
      art_title: "A sculpture of a human figure",
      art_by: "Sophie",
      status: "Live",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approved",
      date_approved: "15-12-2022",
      approved_by: "Liam",
      start_date: "01-04-2023",
      end_date: "01-08-2023",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      art_id: "is12vd5",
      art_title: "A painting of a flower bouquet",
      art_by: "Oliver",
      status: "Draft",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approved",
      date_approved: "15-12-2022",
      approved_by: "Olivia",
      start_date: "20-05-2023",
      end_date: "20-09-2023",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      art_id: "is12vd6",
      art_title: "A digital artwork of abstract shapes",
      art_by: "Eva",
      status: "Pending",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approved",
      date_approved: "15-12-2022",
      approved_by: "Noah",
      start_date: "11-06-2023",
      end_date: "11-10-2023",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      art_id: "is12vd7",
      art_title: "A photograph of a city skyline",
      art_by: "Mia",
      status: "Live",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approved",
      date_approved: "15-12-2022",
      approved_by: "William",
      start_date: "02-07-2023",
      end_date: "02-11-2023",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      art_id: "is12vd8",
      art_title: "A sculpture of an animal",
      art_by: "James",
      status: "Draft",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approved",
      date_approved: "15-12-2022",
      approved_by: "Charlotte",
      start_date: "23-08-2023",
      end_date: "23-12-2023",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      art_id: "is12vd9",
      art_title: "A painting of a landscape",
      art_by: "Amelia",
      status: "Pending",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approved",
      date_approved: "15-12-2022",
      approved_by: "Benjamin",
      start_date: "14-09-2023",
      end_date: "14-01-2024",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
    {
      art_id: "is12vd10",
      art_title: "A digital artwork of geometric patterns",
      art_by: "Henry",
      status: "Live",
      date_submitted: "09-12-2022",
      file: "file",
      action: "Approve",
      date_approved: "15-12-2022",
      approved_by: "Harper",
      start_date: "05-10-2023",
      end_date: "05-02-2024",
      view: <Button onClick={handleFieldButtonClick}>View</Button>,
    },
  ];

  return (
    <>
      <div
        className=" d-flex justify-content-between align-items-center px-4 col-md-6"
        style={{ backgroundColor: "#f1f1f5", borderRadius: "50px" }}
      >
        <InputBase
          className=""
          sx={{
            ml: 1,
            flex: 1,
            px: 1,
          }}
          placeholder="Search..."
          type="search"
        />
        <Box
          sx={{
            width: "25px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 1,
          }}
        >
          <IconButton
            type="button"
            sx={{
              p: "5px",
              backgroundColor: "#3E4755",
              color: "white",
              "&:hover": {
                backgroundColor: "#3E4755",
                color: "white",
              },
            }}
            aria-label="search"
          >
            <Search style={{ fontSize: 25 }} />
          </IconButton>
        </Box>
      </div>
      <div className="d-flex justify-content-center">
        <h1 style={{ color: "black" }}>Art Work</h1>
      </div>
      <div>
        <TableMui
          styleTableTh={{
            color: "black",
            fontWeight: "bold",
            whiteSpace: "nowrap",
          }}
          th={{
            art_id: (
              <>
                Art ID <FilterAltOutlinedIcon />
              </>
            ),
            art_title: (
              <>
                Associated Campaign <FilterAltOutlinedIcon />
              </>
            ),
            // art_by: (
            //   <>
            
            //     Art By <FilterAltOutlinedIcon />
            //   </>
            // ),
            date_submitted: (
              <>
                Submitted on
                <FilterAltOutlinedIcon />
              </>
            ),
            status: (
              <>
                Art Status <FilterAltOutlinedIcon />
              </>
            ),
            action: (
              <>
                Approve/Deny
                <FilterAltOutlinedIcon />
              </>
            ),
            date_approved: (
              <>
                Approved on
                <FilterAltOutlinedIcon />
              </>
            ),
            
            approved_by: (
              <>
                Approved by <FilterAltOutlinedIcon />
              </>
            ),
            // file: (
            //   <>
            //     file
            //     <FilterAltOutlinedIcon />
            //   </>
            // ),
            
            
            // start_date: (
            //   <>
            //     Start Date <FilterAltOutlinedIcon />
            //   </>
            // ),
            // end_date: (
            //   <>
            //     End Date <FilterAltOutlinedIcon />
            //   </>
            // ),
            view: "Button",
          }}
          td={data}
        />
      </div>
      <div className="d-flex justify-content-end me-5">
        <Pagination count={10} shape="rounded" />
      </div>
    </>
  );
};
